import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg, timeAgo } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loading, ErrorState, Empty, PageTitle } from "@/components/States";

export default function Notifications() {
  const { loadBadges } = useAuth();
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
      await api.post("/notifications/read");
      loadBadges();
    } catch (e) {
      setErr(errMsg(e));
    }
  }, [loadBadges]);
  useEffect(() => {
    load();
  }, [load]);
  return (
    <div className="max-w-2xl">
      <PageTitle sub="In-app reminders and updates.">Notifications</PageTitle>
      {err ? <ErrorState message={err} onRetry={load} /> : !items ? <Loading /> : items.length === 0 ? <Empty title="You're all caught up" /> : (
        <div className="bg-white border border-slate-200 rounded-2xl divide-y divide-slate-100 overflow-hidden">
          {items.map((n) => (
            <Link key={n.id} to={n.link || "#"} data-testid={`notification-${n.id}`} className={`block p-4 hover:bg-slate-50 ${n.read ? "" : "bg-blue-50/50"}`}>
              <div className="flex items-start gap-3">
                {!n.read && <span className="mt-1.5 h-2 w-2 rounded-full bg-blue-600 shrink-0" />}
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-bold text-slate-900">{n.title}</p>
                  {n.body && <p className="text-sm text-slate-600">{n.body}</p>}
                </div>
                <span className="text-xs text-slate-400 shrink-0">{timeAgo(n.created_at)}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
